import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

export default function Register({ onSwitchToLogin }) {
  const { register } = useAuth();
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    first_name: '',
    last_name: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validation
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (formData.password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }

    if (formData.username.length < 3) {
      setError('Username must be at least 3 characters');
      return;
    }

    setLoading(true);

    const result = await register({
      username: formData.username,
      email: formData.email,
      first_name: formData.first_name,
      last_name: formData.last_name,
      password: formData.password
    });
    
    if (!result.success) {
      setError(result.error);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4 py-16">
      {/* Background gradient effects */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 -left-32 w-96 h-96 bg-[#DF1283]/20 rounded-full blur-[120px]" />
        <div className="absolute bottom-1/4 -right-32 w-96 h-96 bg-[#4A0A66]/30 rounded-full blur-[120px]" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#D0FF0B]/5 rounded-full blur-[150px]" />
      </div>

      <div className="relative w-full max-w-md">
        {/* Logo/Brand */}
        <div className="text-center mb-8">
          <img 
            src="/calculator-logo.png" 
            alt="UnCloned® Offer Calculator"
            className="h-24 mx-auto"
          />
        </div>

        {/* Register Card */}
        <div className="relative">
          {/* Glow border effect */}
          <div className="absolute -inset-0.5 bg-gradient-to-r from-[#D0FF0B] via-[#0FFFE2] to-[#4A0A66] rounded-2xl opacity-50 blur-sm" />
          
          <div className="relative bg-black/90 backdrop-blur-xl rounded-2xl p-8 border border-[#4A0A66]/30">
            <h2 className="text-2xl font-bold text-white mb-6 text-center">Create Account</h2>
            
            <form onSubmit={handleSubmit} className="space-y-4">
              {error && (
                <div className="bg-[#DF1283]/10 border border-[#DF1283]/50 rounded-lg px-4 py-3 text-[#DF1283] text-sm">
                  {error}
                </div>
              )}

              {/* Name Row */}
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    First Name
                  </label>
                  <input
                    type="text"
                    name="first_name"
                    value={formData.first_name}
                    onChange={handleChange}
                    required
                    data-testid="register-first-name"
                    className="w-full px-4 py-3 bg-[#0a0014] border border-[#4A0A66]/50 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-[#0FFFE2] focus:ring-1 focus:ring-[#0FFFE2]/50 transition-all"
                    placeholder="John"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    Last Name
                  </label>
                  <input
                    type="text"
                    name="last_name"
                    value={formData.last_name}
                    onChange={handleChange}
                    required
                    data-testid="register-last-name"
                    className="w-full px-4 py-3 bg-[#0a0014] border border-[#4A0A66]/50 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-[#0FFFE2] focus:ring-1 focus:ring-[#0FFFE2]/50 transition-all"
                    placeholder="Doe"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Username
                </label>
                <input
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  required
                  data-testid="register-username"
                  className="w-full px-4 py-3 bg-[#0a0014] border border-[#4A0A66]/50 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-[#0FFFE2] focus:ring-1 focus:ring-[#0FFFE2]/50 transition-all"
                  placeholder="johndoe"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  data-testid="register-email"
                  className="w-full px-4 py-3 bg-[#0a0014] border border-[#4A0A66]/50 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-[#0FFFE2] focus:ring-1 focus:ring-[#0FFFE2]/50 transition-all"
                  placeholder="you@example.com"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Password
                </label>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  data-testid="register-password"
                  className="w-full px-4 py-3 bg-[#0a0014] border border-[#4A0A66]/50 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-[#0FFFE2] focus:ring-1 focus:ring-[#0FFFE2]/50 transition-all"
                  placeholder="••••••••"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Confirm Password
                </label>
                <input
                  type="password"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  required
                  data-testid="register-confirm-password"
                  className="w-full px-4 py-3 bg-[#0a0014] border border-[#4A0A66]/50 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-[#0FFFE2] focus:ring-1 focus:ring-[#0FFFE2]/50 transition-all"
                  placeholder="••••••••"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                data-testid="register-submit-button"
                className="w-full py-3 px-4 bg-gradient-to-r from-[#0FFFE2] to-[#D0FF0B] text-black font-semibold rounded-lg hover:opacity-90 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed shadow-lg shadow-[#0FFFE2]/25 mt-2"
              >
                {loading ? (
                  <span className="flex items-center justify-center gap-2">
                    <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                    </svg>
                    Creating Account...
                  </span>
                ) : (
                  'Create Account'
                )}
              </button>
            </form>

            <div className="mt-6 text-center">
              <p className="text-gray-400 text-sm">
                Already have an account?{' '}
                <button
                  onClick={onSwitchToLogin}
                  data-testid="switch-to-login"
                  className="text-[#DF1283] hover:text-[#FF7901] font-medium transition-colors"
                >
                  Sign in
                </button>
              </p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center text-xs text-white/40 mt-8">
          <p>© 2025-2026 UnCloned® Media. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  );
}
